var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddHotlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54399 19.8C8.54399 19.8 4.79999 19.4 4.79999 14.1C4.79999 10 7.77599 7.6 7.77599 7.6C7.77599 7.6 9.02399 9 9.98399 9.5C10.944 10.1 11.328 4 11.328 4C11.328 4 18.24 7.9 18.24 13.8C18.24 19.9 14.4 19.7 14.4 19.7C14.4 19.7 16.128 17.3 16.128 14.5C16.128 11.5 12.384 7.8 12.384 7.8C12.384 7.8 11.904 12.2 10.368 12.8C8.83199 11.9 7.96799 10.5 7.96799 10.5C7.96799 10.5 4.41599 16.3 8.54399 19.8V19.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.712 20.0996C9.79197 19.9996 8.15997 18.6996 8.15997 16.8996C8.15997 15.0996 8.83197 14.2996 8.83197 14.2996C8.83197 14.2996 9.31197 15.2996 9.88797 15.7996C10.464 16.2996 11.616 16.5996 12.192 15.8996C12.768 15.2996 12.96 13.5996 12.96 13.5996C12.96 13.5996 14.304 14.6996 14.112 16.5996C14.016 18.5996 13.248 20.0996 11.712 20.0996Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0915 15.6847V11.6619H22.1085V15.6847H21.0915ZM19.5886 14.1818V13.1648H23.6114V14.1818H19.5886Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHotlist);
export default __webpack_public_path__ + "static/media/add-hotlist.e08b55eed6e6037d5193288045b272d1.svg";
export { ForwardRef as ReactComponent };